<div>
    <footer>
      <div style="text-align: center; margin-top: 15px;">
        <span class="text-xs-center">© Copyright © 2022 BPOne</span>
      </div>
    </footer>
  </div>
